import { render, staticRenderFns } from "./selfServiceReservation.vue?vue&type=template&id=c1a23e24&scoped=true"
import script from "./selfServiceReservation.vue?vue&type=script&lang=js"
export * from "./selfServiceReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a23e24",
  null
  
)

export default component.exports